export default __webpack_public_path__ + "static/media/share.1000f69a.svg";